export default __webpack_public_path__ + "static/media/SIW420G_K075_W00.65e24d9f.webp";